(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  ;(function () {
    function initViewerCounts() {
      var spans = document.querySelectorAll('[id^="viewer-count-"][data-product-id]')
      spans.forEach(function (el) {
        var productId = parseInt(el.getAttribute('data-product-id'), 10)
        if (!productId) return
        var randomOffset = Math.floor(Math.random() * 31)
        function updateCount() {
          var now = new Date()
          var seed = (productId % 100) + 50
          var timeOffset = (now.getHours() * 60 + now.getMinutes()) % 37
          el.textContent = seed + timeOffset + randomOffset
        }
        updateCount()
        setInterval(updateCount, 3000)
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initViewerCounts)
    } else {
      initViewerCounts()
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
